module.exports = __webpack_public_path__ + "img/Nilsen_demonstrasjon.2ed47c27.jpg";